import { IColors } from "@swiggy-private/dls-web-common/dist/components/types.internal";
import React from "react";

export type IAddButtonSize = "normal" | "small" | "xSmall";

export enum ADD_BUTTON_VARIANT {
    DEFAULT = "default",
    POP = "pop",
    TOING = "toing",
}

export interface IAddButtonProps {
    value: number;
    onClickIncrement: (e: React.MouseEvent) => void;
    onClickDecrement: (e: React.MouseEvent) => void;
    helperText?: string;
    size: IAddButtonSize;
    isIncrementDisabled?: boolean;
    isDecrementDisabled?: boolean;
    isUnavailable?: boolean;
    unavailableText?: string;
    unavailableTextColor?: keyof IColors;
    hasOptions?: boolean;
    buttonText?: string;
    updating?: boolean;
    disableBoxShadow?: boolean;
    customQtyColor?: keyof IColors;
    customTextColor?: keyof IColors;
    addButtonVariant?: ADD_BUTTON_VARIANT;
    customBorderColor?: keyof IColors;
    testIds?: {
        containerDataTestId?: string;
        decrementCtaDataTestId?: string;
        incrementCtaDataTestId?: string;
        quantityDataTestId?: string;
        loaderDataTestId?: string;
    };
}

export type ICounterDirection = "increment" | "decrement" | "stable";
